import React from 'react'
import { Link as AntLink, LinkProps as ReactRouterLinkProps } from 'react-router-dom'

export type LinkProps = ReactRouterLinkProps & React.RefAttributes<HTMLAnchorElement>

const Link = (props: LinkProps) => {
    return <AntLink {...props}>{props.children}</AntLink>
}

export default Link
